const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const POSTAL_CODE_PATTERN = /^\d{2}-\d{3}$/;

export function isBlank(value: string): boolean {
  return value.trim().length === 0;
}

export function isValidEmail(value: string): boolean {
  return EMAIL_PATTERN.test(value.trim());
}

export function isValidPostalCode(value: string): boolean {
  return POSTAL_CODE_PATTERN.test(value.trim());
}

export function isPositiveNumber(value: string): boolean {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0;
}

export function isEndTimeAfterStartTime(startTime: string, endTime: string): boolean {
  if (isBlank(startTime) || isBlank(endTime)) {
    return true;
  }
  return endTime > startTime;
}

export function isDateInFuture(isoDate: string): boolean {
  if (isBlank(isoDate)) {
    return false;
  }
  const parsed = new Date(isoDate);
  if (Number.isNaN(parsed.getTime())) {
    return false;
  }
  return parsed.getTime() > Date.now();
}
